<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header show-back-icon @back="back" class="relative">
        <template slot="title">
          <span class="first-level-title">下级渠道商列表</span>

          /
          <span>渠道商详情</span>
        </template>

        <template slot="content">
          <div class="h-full flex items-center">
            <span class="jc-status jc-status--green ml-4px">
              {{ approval_item['label'] }}
            </span>
          </div>

          <div class="jc-list__header--right">
            <el-button
              type="text"
              v-if="distributorData.status === 2"
              slot="children-card-action"
              @click="
                $router.push({
                  name: 'serviceProviderUpdate',
                  params: { id: distributorId },
                })
              "
            >
              重新提交
            </el-button>
          </div>
        </template>
      </el-page-header>
    </div>
    <div class="jc-page-content">
      <el-alert
        type="error"
        v-if="distributorData.status === 2"
        show-icon
        :closable="false"
        :title="`驳回原因：${distributorData.reason}`"
      >
      </el-alert>
      <div class="jc-page-card pb-16px">
        <el-descriptions title="基本信息" column="1">
          <template #extra>
            <el-button
              type="text"
              v-if="distributorData.status === 2"
              slot="link"
              @click="modifyDialog('distributorDialog')"
              >修改</el-button
            >
          </template>
          <el-descriptions-item label="渠道商名称">
            <p>{{ distributorData.distributorName }}</p>
          </el-descriptions-item>
          <el-descriptions-item label="PIN">
            <span>{{ distributorData.pin }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="账号名">
            <span>{{ distributorData.loginName }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="jc-page-card pb-16px">
        <el-descriptions title="工商信息" column="1">
          <template #extra>
            <el-button
              type="text"
              v-if="distributorData.status === 2"
              slot="link"
              @click="modifyDialog('businessDialog')"
              >修改</el-button
            >
          </template>
          <el-descriptions-item label="营业执照号">
            <p>{{ distributorData.businessLicense }}</p>
          </el-descriptions-item>
          <el-descriptions-item label="法定代表人">
            <span>{{ distributorData.legalRepresentative }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="营业执照">
            <el-image
              style="width: 200px; height: 200px"
              :src="distributorData.businessLicensePicUri"
              :preview-src-list="[distributorData.businessLicensePicUri]"
            />
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="jc-page-card pb-16px">
        <el-descriptions title="公司信息" column="1">
          <template #extra>
            <el-button
              type="primary"
              v-if="
                distributorData.status === 1 || distributorData.status === 2
              "
              @click="modifyDialog('companyDialog')"
              >修改</el-button
            >
          </template>
          <el-descriptions-item label="主营业务描述">
            <p>{{ distributorData.businessDesc }}</p>
          </el-descriptions-item>
          <el-descriptions-item label="办公地址">
            <p>{{ distributorData.workAddress }}</p>
          </el-descriptions-item>
          <el-descriptions-item label="联系人姓名">
            <span>{{ distributorData.contracter }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            <p>{{ distributorData.tel }}</p>
          </el-descriptions-item>
          <el-descriptions-item label="邮箱">
            <p>{{ distributorData.email }}</p>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    <edit-company-info
      :infoData="distributorData"
      ref="companyDialog"
      @submitSuccess="getDetail"
    ></edit-company-info>

    <edit-bank-info
      :infoData="distributorData"
      ref="bankDialog"
      @submitSuccess="getDetail"
    ></edit-bank-info>

    <edit-business-info
      :infoData="distributorData"
      ref="businessDialog"
      @submitSuccess="getDetail"
    ></edit-business-info>

    <edit-distributor-name
      :infoData="distributorData"
      ref="distributorDialog"
      @submitSuccess="getDetail"
    ></edit-distributor-name>

    <edit-erp
      :infoData="distributorData"
      ref="erpDialog"
      @submitSuccess="getDetail"
    ></edit-erp>
  </div>
</template>

<script>
import { getSecondInfo, displayExtraInfo } from '@/api/distributor-api.js'
import { APPROVAL_STATUS_MAP } from '@/utils/constant.js'
import routerMixins from '@/mixins/router-mixins.js'
import { isNull } from '@/utils'
export default {
  props: {},
  components: {
    EditCompanyInfo: () =>
      import('@/views/service-provider/models/EditCompanyInfo.vue'),
    EditBankInfo: () =>
      import('@/views/service-provider/models/EditBankInfo.vue'),
    EditBusinessInfo: () =>
      import('@/views/service-provider/models/EditBusinessInfo.vue'),
    EditDistributorName: () =>
      import('@/views/service-provider/models/EditDistributorName.vue'),
    EditErp: () => import('@/views/service-provider/models/EditErp.vue'),
  },
  mixins: [routerMixins],
  data() {
    return {
      showBank: 1,
      distributorId: this.$route.params.id || '',
      //'8661452ecf574896b9ec172fdd1a8974'
      distributorData: {},
      approval_item: {
        label: '',
        type: '',
      },
      showErp: false,
    }
  },
  created() {
    if (this.distributorId !== '') {
      this.getDetail()
      this.displayExtraInfo()
    }
    let { hasSub, hasSubReturn, subReturnMode } = this.$store.state.distributor
    this.showBank = hasSub || hasSubReturn
    if (isNull(this.showBank) || subReturnMode !== 1) {
      this.showBank = 1
    }
  },
  watch: {},
  computed: {},
  filters: {},
  methods: {
    async getDetail() {
      let { result } = await getSecondInfo({
        distributorId: this.distributorId,
      })
      if (result && result.distributorResult) {
        this.distributorData = result.distributorResult
        this.approval_item = APPROVAL_STATUS_MAP[this.distributorData.status]
      }
    },
    modifyDialog(name) {
      this.$refs[name].showDialog()
    },
    back() {
      this.$router.back()
    },
    async displayExtraInfo() {
      const { result = {} } = await displayExtraInfo()
      this.showErp = result.result && result.result.isShow
    },
  },
}
</script>

<style>
.jc-page-header .jc-button--text {
  padding: 0;
  margin-top: 20px;
  vertical-align: top;
}
.jc-page-header .jc-status {
  margin-right: 10px;
}
</style>
